export const getUrl = (path, id = null) => {
    if (path.includes("{id}")) {
        if (id === null) {
            throw new Error('Id Not Found');
        }
        return path.replace('{id}', id);
    }

    return path;
}